import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const differentialScanningCalorimetry = {
    jpath: ['spectra', 'differentialScanningCalorimetry'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default differentialScanningCalorimetry;
//# sourceMappingURL=differentialScanningCalorimetry.js.map